import React from "react";

const OnboardingStep4 = ({ activeItems, toggleSubMenu, handleNext }) => {
  const isActive = (item) => activeItems.includes(item);

  const handleToggle = (item) => {
    const groupItems = [
      "motivation-0",
      "motivation-1",
      "motivation-2",
      "motivation-3",
      "motivation-4",
    ];
    groupItems.forEach((activeItem) => {
      if (isActive(activeItem)) {
        toggleSubMenu(activeItem);
      }
    });
    toggleSubMenu(item);
  };

  const groupItems = [
    "motivation-0",
    "motivation-1",
    "motivation-2",
    "motivation-3",
    "motivation-4",
  ];

  const motivationLabels = [
    "Struggling",
    "Unsure",
    "Getting there",
    "Motivated",
    "Determined",
  ];

  const handleNextWithStorage = () => {
    const motivational = groupItems.findIndex((motivationLevel) => isActive(motivationLevel));
    if (motivational !== -1) {
      localStorage.setItem("motivation", motivational + 1);
    }
    handleNext();
  };

  const isItemActive = groupItems.some(isActive);

  return (
    <div className="modal-container animated-onboarding onboarding-step4 fadeIn">
      <div className="modal-container-title fade1 heading">
        How motivated are you to feel better and get back to what you love?
      </div>

      <ul className="selection selection-flex-col selection-ico fade3 with-box-icon nowrap mt-50">
        {groupItems.map((motivationLevel, index) => (
          <li
            key={motivationLevel}
            className={`with-icon ${isActive(motivationLevel) ? "active" : ""}`}
            onClick={() => handleToggle(motivationLevel)}
          >
            <p className="icon-index">{index + 1}</p>
            <div className={`div-ico ico ico-motivation-${index}`}></div>
            <span className={`icon icon-${index}`}></span>
            <p className="icon-text">{motivationLabels[index]}</p>
          </li>
        ))}
      </ul>

      {isItemActive && (
        <>
          <div className="nav-container fade-fast">
            <button className="btn-next next-btn" onClick={handleNextWithStorage}>
              Next
            </button>
          </div>
          <div className="dot-container fade-fast">
            <div className="dot-unchecked"></div>
            <div className="dot-unchecked"></div>
            <div className="dot-unchecked"></div>
            <div className="dot-checked"></div>
            <div className="dot-unchecked"></div>
            <div className="dot-unchecked"></div>
          </div>
        </>
      )}
    </div>
  );
};

export default OnboardingStep4;
